<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        label="公司名称"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'company_name',
            { rules: [{ required: true, message: '请填写公司名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item
        label="公司简称"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          placeholder="如瑟悟网络科技有限公司简称SW"
          v-decorator="[
            'short_name',
            { rules: [{ required: true, message: '请填写公司简称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item
        label="包含部门"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-select
          mode="multiple"
          v-decorator="[
            'department_id',
            { rules: [{ required: true, message: '请选择包含部门!' }] }
          ]"
          placeholder="请选择包含部门"
        >
          <a-select-option
            v-for="(item, i) in departmentList"
            :key="i"
            :value="item.department_id"
            >{{ item.department_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      departmentList: [],
      companyList: []
    };
  },
  mounted() {
    this.getDepartmentList(); //获取部门列表
  },
  methods: {
    getDepartmentList() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.customer +
        "Company/departmentList";
      let pramas = {
        per_page: 10000,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.departmentList = res.data.data.data;
        }
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(this.$store.state.token)
      this.form.validateFields((err, pramas) => {
        if (!err) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.customer +
            "Company/addCompany";
          axios
            .post(url, {
              company_name: pramas.company_name,
              department_id: pramas.department_id,
              short_name: pramas.short_name,
              token: window.localStorage.getItem("xnwfPcToken")
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.form.resetFields();
                this.$emit("hideInAdd", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>
